import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface IBatchesListDataTableRowFormMeta {
    // Table modal form fields
    id: FormInputMeta;
    name: FormInputMeta;
    type: FormInputMeta;
    category: FormInputMeta;
    executedFunction: FormInputMeta;
    
    schema: any;
}

const batchesListDataTableRowFormMeta = {} as IBatchesListDataTableRowFormMeta;

batchesListDataTableRowFormMeta.id = {
  name: "id",
  type: "text",
  label: "ID",
  placeholder: "",
  validation: yup.string().required("Champ obligatoire"),
};

batchesListDataTableRowFormMeta.name = {
    name: "name",
    type: "text",
    label: "Name",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire"),
};
  
  batchesListDataTableRowFormMeta.type = {
    name: "type",
    type: "select",
    label: "Type",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire"),
};
  
  batchesListDataTableRowFormMeta.category = {
    name: "category",
    type: "select",
    label: "Category",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire"),
};
  
  batchesListDataTableRowFormMeta.executedFunction = {
    name: "executedFunction",
    type: "text",
    label: "Executed Function",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire"),
};
  

batchesListDataTableRowFormMeta.schema = yup.object().shape(getValidationSchema(batchesListDataTableRowFormMeta));

export default batchesListDataTableRowFormMeta;